import { ReactElement, useState } from 'react'
import { FormattedMessage, defineMessages, useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'
import { Formik } from 'formik'
import { keys, isEmpty } from 'lodash'

import { Select } from 'components/v2/Select'
import { Tag } from 'components/v2/Tag'
import { PlaceAutocomplete } from 'features/Places/components/PlaceAutocomplete'
import { getQueryString } from 'utils/route'
import { BOOLEAN } from 'utils/boolean'
import {
  FilterHeader,
  FilterToggle,
  FilterWrapper,
  FiltersContainer,
  FiltersSubmit,
  FiltersWrapper,
  TagsWrapper
} from 'components/Filters'
import { CompanyAutocomplete } from 'features/Companies/components/CompanyAutocomplete'

const YES_NO_LIST = [BOOLEAN.TRUE, BOOLEAN.FALSE]

const messages = defineMessages({
  select: {
    id: 'dictionary.select',
    defaultMessage: 'Select'
  },
  selectOrigin: {
    id: 'bookings.filters.selectOrigin',
    defaultMessage: 'Select origin'
  },
  selectDestination: {
    id: 'bookings.filters.selectDestination',
    defaultMessage: 'Select destination'
  },
  selectCompany: {
    id: 'bookings.filters.selectCompany',
    defaultMessage: 'Select company'
  }
})

const booleanMessages = defineMessages({
  true: {
    id: 'dictionary.yes',
    defaultMessage: 'Yes'
  },
  false: {
    id: 'dictionary.no',
    defaultMessage: 'No'
  }
})

export const SegmentsFilters = ({ filters }: TSFixMe): TSFixMe => {
  const navigate = useNavigate()
  const intl = useIntl()
  const [isShowingFilters, showFilters] = useState(false)

  const toggleFilters = (): TSFixMe => {
    showFilters(!isShowingFilters)
  }

  const filterSegments = (values: TSFixMe): void => {
    const query = {
      hasPricing: values.hasPricing,
      hasDuration: values.hasDuration,
      origin: values.origin.id,
      destination: values.destination.id,
      company: values.company.id
    }

    navigate(`/segments?${getQueryString(query)}`)
  }
  const initialValues = {
    // @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
    hasPricing: booleanMessages[filters.hasPricing] ? filters.hasPricing : '',
    // @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
    hasDuration: booleanMessages[filters.hasDuration] ? filters.hasDuration : '',
    origin: filters.origin || { name: '' },
    destination: filters.destination || { name: '' },
    company: filters.company || { name: '' }
  }

  return (
    <Formik initialValues={initialValues} onSubmit={filterSegments} enableReinitialize>
      {(props): ReactElement => {
        const { handleChange, handleSubmit, setFieldValue, values } = props

        const handleSelectChange = (event: TSFixMe): void => {
          const {
            target: { id, value }
          } = event

          handleChange(event)

          filterSegments({
            ...values,
            [id]: value
          })
        }

        const handleFilterDelete = (id: TSFixMe): void => {
          setFieldValue(id, '')
          filterSegments({
            ...values,
            [id]: ''
          })
        }

        return (
          <form onSubmit={handleSubmit}>
            <div>
              <FilterHeader>
                <FilterWrapper>
                  <div>
                    <FilterToggle onClick={toggleFilters} />
                  </div>
                  <TagsWrapper>
                    {keys(filters).map((filterKey): TSFixMe => {
                      let label, value
                      const filterValue = filters[filterKey]

                      if (isEmpty(filterValue)) return null

                      switch (filterKey) {
                        case 'hasPricing':
                          label = <FormattedMessage id="segments.filters.hasPricing" defaultMessage="Has pricing" />
                          // @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
                          value = booleanMessages[filterValue] && intl.formatMessage(booleanMessages[filterValue])
                          break
                        case 'hasDuration':
                          label = <FormattedMessage id="segments.filters.hasDuration" defaultMessage="Has duration" />
                          // @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
                          value = booleanMessages[filterValue] && intl.formatMessage(booleanMessages[filterValue])
                          break
                        case 'origin':
                          label = <FormattedMessage id="dictionary.origin" defaultMessage="Origin" />

                          if (!filterValue?.id) return null

                          value = filterValue.name
                          break
                        case 'destination':
                          label = <FormattedMessage id="dictionary.destination" defaultMessage="Destination" />

                          if (!filterValue?.id) return null

                          value = filterValue.name
                          break
                        case 'company':
                          label = <FormattedMessage id="dictionary.company" defaultMessage="Company" />

                          if (!filterValue?.id) return null

                          value = filterValue.name
                          break
                      }

                      return (
                        <Tag key={filterKey} onDelete={handleFilterDelete.bind(this, filterKey)}>
                          {label}: {value}
                        </Tag>
                      )
                    })}
                  </TagsWrapper>
                </FilterWrapper>
              </FilterHeader>
              <FiltersWrapper isShowingFilters={isShowingFilters}>
                <FiltersContainer>
                  <Select
                    id="hasPricing"
                    value={values.hasPricing}
                    onChange={handleSelectChange}
                    label={<FormattedMessage id="segments.filters.hasPricing" defaultMessage="Has pricing" />}
                  >
                    <option value="">{intl.formatMessage(messages.select)}</option>
                    {YES_NO_LIST.map((boolean): TSFixMe => {
                      return (
                        <option value={boolean} key={boolean}>
                          {/* @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message*/}
                          {booleanMessages[boolean] && intl.formatMessage(booleanMessages[boolean])}
                        </option>
                      )
                    })}
                  </Select>
                  <Select
                    id="hasDuration"
                    value={values.hasDuration}
                    onChange={handleSelectChange}
                    label={<FormattedMessage id="segments.filters.hasDuration" defaultMessage="Has duration" />}
                  >
                    <option value="">{intl.formatMessage(messages.select)}</option>
                    {YES_NO_LIST.map((boolean): TSFixMe => {
                      return (
                        <option value={boolean} key={boolean}>
                          {/* @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message*/}
                          {booleanMessages[boolean] && intl.formatMessage(booleanMessages[boolean])}
                        </option>
                      )
                    })}
                  </Select>
                  <PlaceAutocomplete
                    placeholder={intl.formatMessage(messages.selectOrigin)}
                    value={values.origin.name}
                    label={<FormattedMessage id="dictionary.origin" defaultMessage="Origin" />}
                    onChange={(place: TSFixMe): TSFixMe => {
                      setFieldValue('origin', place)

                      filterSegments({
                        ...values,
                        origin: place
                      })
                    }}
                  />
                  <PlaceAutocomplete
                    placeholder={intl.formatMessage(messages.selectDestination)}
                    value={values.destination.name}
                    label={<FormattedMessage id="dictionary.destination" defaultMessage="Destination" />}
                    onChange={(place: TSFixMe): TSFixMe => {
                      setFieldValue('destination', place)

                      filterSegments({
                        ...values,
                        destination: place
                      })
                    }}
                  />
                  <CompanyAutocomplete
                    placeholder={intl.formatMessage(messages.selectCompany)}
                    value={values.company.name}
                    label={<FormattedMessage id="dictionary.company" defaultMessage="Company" />}
                    onChange={(company: TSFixMe): TSFixMe => {
                      setFieldValue('company', company)

                      filterSegments({
                        ...values,
                        company: company
                      })
                    }}
                  />
                </FiltersContainer>
              </FiltersWrapper>
            </div>
            <FiltersSubmit />
          </form>
        )
      }}
    </Formik>
  )
}
